export const serverURL = "api/index.php"

export const siteTitle = 'VOC'

export const loginType = 'local'

export const getHeader = function () {
	const headers = {
		'Accept': 'application/json'
	}
	return headers
}